import { render, staticRenderFns } from "./passWord.vue?vue&type=template&id=7b523f4e&scoped=true"
import script from "./passWord.vue?vue&type=script&lang=js"
export * from "./passWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b523f4e",
  null
  
)

export default component.exports